import React from "react";
import {
  Alert,
  Snackbar,
  Slide,
  SxProps,
  Theme,
} from "@mui/material";
import { SnackbarProps } from "src/interfaces/snackbar";

interface TyfhuSnackProps {
  snackbar: SnackbarProps;
  handleClose: () => void;
  sx?: SxProps<Theme>;
}

const SlideTransition = (props: any) => {
  return <Slide {...props} direction="left" />;
};

const TyfhuSnack = ({
  snackbar,
  handleClose,
  sx,
}: TyfhuSnackProps) => {
  return (
    <Snackbar
      open={snackbar?.open}
      autoHideDuration={3000}
      onClose={(_, reason) => {
        if (reason === "clickaway") return;
        handleClose();
      }}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      TransitionComponent={SlideTransition}
    >
      <Alert
        onClose={handleClose}
        severity={snackbar?.severity ?? "error"}
        variant="filled"
        sx={{
          minWidth: 300,
          maxWidth: 420,
          borderRadius: "12px",
          boxShadow:
            "0px 10px 25px rgba(0, 0, 0, 0.15)",
          fontSize: "14px",
          alignItems: "center",
          ...sx,
        }}
      >
        {snackbar?.message}
      </Alert>
    </Snackbar>
  );
};

export default TyfhuSnack;